import EmployeeJobSearch from "component/employeeProfile/employeeJobSearch";
import{ memo } from "react";

const JobSearchPage = () =>{
    return (
        <EmployeeJobSearch/>
    );
}

export default memo(JobSearchPage);